import { create } from "zustand";

interface SortProperties {
  sortBy: string;
  order: "asc" | "desc";
}
interface SortOption {
  id: string;
  field: string;
  order: "asc" | "desc";
}

interface SortState {
  selectedSortField: string;
  sorts: SortOption[];

  setSelectedSortField: (data: any) => void;
  setSorts: (data: SortOption[]) => void;
  getSorts: () => SortProperties[];
}

export const useSortStore = create<SortState>((set, get) => ({
  selectedSortField: "",
  sorts: [],

  setSelectedSortField: (field) => {
    set({ selectedSortField: field });

    if (field) {
      const { sorts } = get();

      const isAlreadySorted = sorts.some((sort) => sort.field === field);

      if (!isAlreadySorted) {
        set({
          sorts: [...sorts, { id: `${field}-default`, field, order: "asc" }],
        });
      }
    }
  },

  setSorts: (data: SortOption[]) => {
    set({ sorts: data });
  },

  getSorts: () => {
    return get().sorts.map(({ field, order }) => ({ sortBy: field, order }));
  },
}));
